import React from "react";
import { Chip, Tooltip } from "@material-ui/core";
import { PersonOutline } from "@material-ui/icons";
import { isContactLead } from "../../helpers/contactIdentity";

const ContactLeadBadge = ({ contact }) => isContactLead(contact) ? (
  <Tooltip title={"Cadastro ainda n\u00e3o confirmado pela equipe"}>
    <Chip label="Lead" icon={<PersonOutline />} size="small" style={{ backgroundColor: "#fff4cc", color: "#6b5100", border: "1px solid #d8b64b", marginTop: 4, marginBottom: 4, maxWidth: "100%" }} />
  </Tooltip>
) : null;
export default ContactLeadBadge;
